module.exports = __webpack_public_path__ + "img/bg-kxzd.ca63028c.png";